import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { ACCESS_TOKEN } from '@/store/mutation-types'
import ls from '@/utils/Storage'
import { setDocumentTitle } from '@/utils/domUtil'
import type { Router } from 'vue-router'
import { notification } from 'ant-design-vue'
import { useLogin } from '@/store/login'
import { transformRoutes, extractButtonCodeNos } from '@/utils/resetTreeMenu'
import generateAsyncRoutes from './generateAsyncRoutes'
import { example } from './exampleRouterMap'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'loginIndex', 'register', 'registerResult'] // 不进行拦截的路由名称集合
const defaultRoutePath = '/'
let hasAddBusinessRoutes = false

export const setupBeforeEach = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    NProgress.start() // 加载进度条
    setDocumentTitle(to)
    if (ls.get(ACCESS_TOKEN)) {
      const loginApi = useLogin()
      await loginApi.getUserInfo()
      const { treeMenu, roleType } = loginApi.userInfos as any
      if (!hasAddBusinessRoutes) {
        if (roleType === 'admin') {
          router.addRoute(example as any)
          hasAddBusinessRoutes = true
          if (to.path === '/') {
            next({
              path: example.redirect as string,
              replace: true
            })
          } else {
            next({
              path: to.path,
              query: to.query,
              hash: to.hash,
              replace: true
            })
          }
          return
        }
        const menu = await transformRoutes(treeMenu)
        const buttonCodeNos = extractButtonCodeNos(treeMenu)
        loginApi.setAuthBtnList(buttonCodeNos)
        const homePath = await generateAsyncRoutes(router, menu)
        hasAddBusinessRoutes = true
        if (to.path === '/') {
          next({
            path: homePath,
            replace: true
          })
        } else {
          next({
            path: to.path,
            query: to.query,
            hash: to.hash,
            replace: true
          })
        }
        return
      }

      /* has token */
      if (to.path === '/login') {
        next({ path: defaultRoutePath })
        NProgress.done()
      } else {
        next()
      }
    } else {
      if (whiteList.includes(to.name as any)) {
        // 在免登录白名单，直接进入
        next()
      } else {
        next({ path: '/login', query: { redirect: to.fullPath } })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  })

  // 路由懒加载失败时的提示
  router.onError((error) => {
    if (window.env === 'localhost') {
      notification.error({
        message: 'Dynamic import error',
        description: error.stack
      })
    } else {
      router.push({ name: 'error', params: { errorMsg: error.stack } })
    }
  })
}

export const setupAfterEach = (router: Router) => {
  router.afterEach(() => {
    NProgress.done() // finish progress bar
  })
}
